var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "sc-message--file",
      style: _vm.messageColors,
      on: { click: _vm.onFileMessageClick }
    },
    [
      _c("div", { staticClass: "sc-message--file-icon" }, [
        _c("a", { attrs: { href: "#" } }, [
          _vm.data.file.type
            ? _c("img", {
                class: {
                  "sc-image": true,
                  "sc-file-icon": !_vm.data.file.type.includes("image")
                },
                attrs: {
                  src: _vm.data.file.type.includes("image")
                    ? _vm.data.url
                    : _vm.getNonImageFileIcon(_vm.data.file.type)
                }
              })
            : _vm._e()
        ])
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "sc-message--file-name", style: _vm.messageColors },
        [
          _c("a", { attrs: { href: "#", target: "_blank" } }, [
            _vm._v(_vm._s(_vm.data.file.name || ""))
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "sc-message--file-text", style: _vm.messageColors },
        [
          _vm._v(_vm._s(_vm.data.text)),
          _vm.data.meta
            ? _c(
                "p",
                { staticClass: "sc-message--meta", style: _vm.messageColors },
                [_vm._v(_vm._s(_vm.data.meta))]
              )
            : _vm._e()
        ]
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c4312a72", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c4312a72","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/vue-beautiful-chat/src/messages/FileMessage.vue
// module id = 1906
// module chunks = 116